import React, { ReactNode, createContext, useContext, useState } from 'react';

interface GlobalContextProps {
  isOrgSwitching: boolean;
  setIsOrgSwitching: (isOrgSwitching: boolean) => void;
}

export const GlobalContext = createContext<GlobalContextProps | undefined>(undefined);

export const GlobalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOrgSwitching, setIsOrgSwitching] = useState(false);

  return (
    <GlobalContext.Provider
      value={{
        isOrgSwitching,
        setIsOrgSwitching,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (context === undefined) {
    throw new Error('useGlobal must be used within a GlobalProvider');
  }
  return context;
};
